module.exports = __webpack_public_path__ + "img/default-avater-male.51ac0fe2.jpg";